import { render, staticRenderFns } from "./Scrollbar.vue?vue&type=template&id=5b4c4e32&scoped=true&"
import script from "./Scrollbar.vue?vue&type=script&lang=js&"
export * from "./Scrollbar.vue?vue&type=script&lang=js&"
import style0 from "./Scrollbar.vue?vue&type=style&index=0&id=5b4c4e32&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b4c4e32",
  null
  
)

export default component.exports